import { asDate } from "@@/shared/date-time/as-date";
import type { NearestMinutes } from "@@/shared/nearest-minutes";
import { roundToNearestMinutes } from "date-fns";
import type { IsoAndUnixTimestamp } from "../../shared/date-time/iso-and-unix";

const swedishTimeZone = "Europe/Stockholm";

const formatterTimeOfDayHourMinute = new Intl.DateTimeFormat("sv-SE", {
    timeZone: swedishTimeZone,
    hour: "2-digit",
    minute: "2-digit",
});

const getTimeOfDay = (
    date: IsoAndUnixTimestamp,
    timeZone = swedishTimeZone,
) => {
    const formatter =
        timeZone === swedishTimeZone
            ? formatterTimeOfDayHourMinute
            : new Intl.DateTimeFormat("sv-SE", {
                  timeZone,
                  hour: "2-digit",
                  minute: "2-digit",
              });
    return formatter.format(asDate(date));
};

const formatterTimeOfDayHour = new Intl.DateTimeFormat("sv-SE", {
    timeZone: swedishTimeZone,
    hour: "2-digit",
});

const getTimeOfDayHour = (date: Date) => {
    return formatterTimeOfDayHour.format(date);
};
const getTimeOfDayHourMinute = (date: Date) => {
    return formatterTimeOfDayHourMinute.format(date);
};

const onlyHourFormatter = new Intl.DateTimeFormat("sv-SE", {
    hour: "2-digit",
    timeZone: swedishTimeZone,
});

const hourMinuteFormatter = new Intl.DateTimeFormat("sv-SE", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: swedishTimeZone,
});
const getTimeOfDayRounded = (
    date: IsoAndUnixTimestamp,
    nearestTo?: NearestMinutes,
    shortenMinutes = false,
) => {
    const rounded = roundToNearestMinutes(asDate(date), { nearestTo });
    const formatter =
        rounded.getMinutes() === 0 && shortenMinutes
            ? onlyHourFormatter
            : hourMinuteFormatter;

    return formatter.format(rounded);
};

export {
    getTimeOfDay,
    getTimeOfDayHour,
    getTimeOfDayHourMinute,
    getTimeOfDayRounded,
};
